module.exports = __webpack_public_path__ + "static/media/slj_author.6f0b9185.jpg";